import { NextSeo } from 'next-seo';
import UtsavCard from '@cont/Events/UtsavCard';
import SimpleLayout from '@layout/SimpleLayout/SimpleLayout';
import { useRouter } from 'next/router';
import { fetchEventData } from '@api/fetchers/events';

const RegisterPage = ({ data, summitKey }) => {
  const seoTitle = `Utsav ${summitKey}`;
  const seoDescription = `${summitKey} on Unacademy`;
  const canonical = `https://unacademy.com/event/${summitKey}/register`;
  const router = useRouter();
  const { query } = router;
  const utsavReferrer = (query?.utsav_referrer as string) || '';
  const utmSource = (query?.utm_source as string) || '';
  const utmCampaign = (query?.utm_campaign as string) || '';
  const utmMedium = (query?.utm_medium as string) || '';
  const utmContent = (query?.utm_content as string) || '';
  const referringDomain = (query?.referring_domain as string) || '';
  const gclid = (query?.gclid as string) || '';
  return (
    <>
      <NextSeo
        title={seoTitle}
        description={seoDescription}
        canonical={canonical}
      />
      <UtsavCard
        data={data}
        utsavReferrer={utsavReferrer}
        utmSource={utmSource}
        utmCampaign={utmCampaign}
        utmMedium={utmMedium}
        utmContent={utmContent}
        referringDomain={referringDomain}
        gclid={gclid}
      />
    </>
  );
};

RegisterPage.pageInfo = {
  isMWebSupported: true,
  name: 'Utsav Page',
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true,
    showLogin: true,
    hideNav: true
  }
};

export const getServerSideProps = async ({ params }) => {
  const { summitKey } = params;
  if (!summitKey) {
    return {
      notFound: true
    };
  }

  try {
    const res = await fetchEventData(summitKey);
    if (!res) {
      return {
        notFound: true
      };
    }
    return {
      props: {
        summitKey,
        data: res || {}
      }
    };
  } catch (error) {
    return {
      notFound: true
    };
  }
};

export default RegisterPage;

RegisterPage.Layout = SimpleLayout;
